import { BrowserModule } from '@angular/platform-browser';
import { AgmCoreModule } from '@agm/core';
import { NgModule } from '@angular/core';
import { GlMapGoogleComponent } from './gl-map-google.component';



@NgModule({
  declarations: [GlMapGoogleComponent],
  imports: [
    BrowserModule,
    AgmCoreModule    
  ],
  exports: [GlMapGoogleComponent]
})
export class GlMapGoogleModule { }
